import { useState, useEffect, useContext, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';
import layoutService from '../services/layoutService';

const useSidebarConfig = () => {
    const { user, isAuthenticated } = useContext(AuthContext);
    const [config, setConfig] = useState(() => layoutService.getCachedSidebarConfig());
    const [loading, setLoading] = useState(true);

    const fetchConfig = useCallback(async () => {
        if (!isAuthenticated || !user) {
            setConfig(null);
            setLoading(false);
            return;
        }

        try {
            const result = await layoutService.getMySidebarConfig();
            setConfig(result || null);
        } catch {
            setConfig(null);
        } finally {
            setLoading(false);
        }
    }, [isAuthenticated, user]);

    useEffect(() => {
        fetchConfig();
    }, [fetchConfig]);

    return {
        config,
        configuration: config?.configuration || null,
        loading,
        refetch: fetchConfig
    };
};

export default useSidebarConfig;
